import { RouterProvider as TanStackRouterProvider, type AnyRouter } from "@tanstack/react-router";
import { useClient } from "urql";
import { useAuth } from "./auth-provider";
import FullscreenLoader from "@/components/fullscreen-loader";

type RouterProviderProps = {
  router: AnyRouter;
};

export function RouterProvider({ router }: RouterProviderProps) {
  const auth = useAuth();
  const urqlClient = useClient();

  // Prevent flashing protected routes while Auth0 determines user status
  if (auth.isLoading) {
    return <FullscreenLoader />;
  }

  return <TanStackRouterProvider router={router} context={{ urqlClient, auth }} />;
}
